import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar"]

  connect() {
    // Restore sidebar state from localStorage on mobile
    this.updateActiveLink()
  }

  toggle() {
    const sidebar = this.sidebarTarget
    sidebar.classList.toggle("show")
  }

  close() {
    const sidebar = this.sidebarTarget
    sidebar.classList.remove("show")
  }

  updateActiveLink() {
    const currentPath = window.location.pathname
    this.element.querySelectorAll(".sidebar-link").forEach(link => {
      const href = link.getAttribute("href")
      if (href && currentPath.startsWith(href) && href !== "/") {
        link.classList.add("active")
      }
    })
  }
}
